import React, { Component } from 'react';

interface ICountToState {
    count: number;
}

interface ICountToProps {
    speed: number;
    from: number;
    to: number;
    numberToAdd: number;
}

export class CountTo extends Component<ICountToProps, ICountToState> {
    private counter: NodeJS.Timeout;
    constructor(props: any) {
        super(props);
        this.state = {
            count: this.props.from,
        };
    }

    componentDidMount() {
        this.counter = setInterval(() => {
            this.setState({
                count: this.state.count + this.props.numberToAdd,
            });

            if (this.state.count >= this.props.to) {
                clearInterval(this.counter);
            }
        }, this.props.speed);
    }

    componentWillUnmount() {
        clearInterval(this.counter);
    }

    render() {
        return <span>{this.state.count}</span>;
    }
}
